import React from "react";
import AddressTypes from "@/utils/AddressTypes";
import { Field, FieldGrid, Input, Select } from "@/screen/Companies/Styles/CompanyFormFieldStyles";
import type { CatalogOption, CompanyAddressFormData } from "@/screen/Companies/CompanyDetails/companyDetailsForm";

interface CompanyAddressFieldsProps
{
    address: CompanyAddressFormData;
    countryOptions: CatalogOption[];
    onChange: (field: keyof CompanyAddressFormData, value: string) => void;
}

const RoadTypeOptions: CatalogOption[] = AddressTypes.map((roadType) => ({ value: roadType.value, text: roadType.text }));

// Campos de un domicilio de la empresa (fiscal o social)
const CompanyAddressFields: React.FC<CompanyAddressFieldsProps> = ({ address, countryOptions, onChange }) =>
{
    const handle = (field: keyof CompanyAddressFormData) => (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>): void =>
        onChange(field, e.target.value);

    return(
        <FieldGrid>
            <Field>
                <span>País de residencia <b>*</b></span>
                <Select value={address.country} onChange={handle("country")}>
                    <option value="">-- Seleccionar --</option>
                    {countryOptions.map((option) => <option key={option.value} value={option.value}>{option.text}</option>)}
                </Select>
            </Field>
            <Field>
                <span>Código postal <b>*</b></span>
                <Input type="text" value={address.zipCode} onChange={handle("zipCode")} maxLength={10} autoComplete="off" />
            </Field>
            <Field>
                <span>Localidad <b>*</b></span>
                <Input type="text" value={address.city} onChange={handle("city")} maxLength={100} autoComplete="off" />
            </Field>
            <Field>
                <span>Tipo de vía <b>*</b></span>
                <Select value={address.roadType} onChange={handle("roadType")}>
                    <option value="">-- Seleccionar --</option>
                    {RoadTypeOptions.map((option) => <option key={option.value} value={option.value}>{option.text}</option>)}
                </Select>
            </Field>
            <Field>
                <span>Dirección <b>*</b></span>
                <Input type="text" value={address.streetName} onChange={handle("streetName")} maxLength={150} autoComplete="off" />
            </Field>
            <Field>
                <span>Número <b>*</b></span>
                <Input type="text" value={address.streetNumber} onChange={handle("streetNumber")} maxLength={10} autoComplete="off" />
            </Field>
            <Field>
                <span>Piso</span>
                <Input type="text" value={address.streetFloor} onChange={handle("streetFloor")} maxLength={10} autoComplete="off" />
            </Field>
            <Field>
                <span>Puerta</span>
                <Input type="text" value={address.streetDoor} onChange={handle("streetDoor")} maxLength={10} autoComplete="off" />
            </Field>
            <Field>
                <span>Información adicional</span>
                <Input type="text" value={address.streetOther} onChange={handle("streetOther")} maxLength={100} autoComplete="off" />
            </Field>
        </FieldGrid>
    );
};

export default CompanyAddressFields;
